import { render, staticRenderFns } from "./AdminPredefinedProductsEditScreen.vue?vue&type=template&id=97007f2e&scoped=true&"
import script from "./AdminPredefinedProductsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminPredefinedProductsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97007f2e",
  null
  
)

export default component.exports